import React from "react";
import { Col, Card } from "react-bootstrap";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import EmptyState from "./EmptyState";

const MessagesOverTimeChart = ({ data, messageTypes, messageTypeColors }) => {
  const hasData = data?.length > 0;

  return (
    <Col md={4} className="mb-4">
      <Card style={{ minHeight: "360px" }}>
        <Card.Body>
          <h6 className="fw-bold mb-2 text-muted">{`Signals Intercepted Over Time`}</h6>
          {!hasData ? (
            <EmptyState title="No signals found" />
          ) : (
            <ResponsiveContainer width="95%" height={300}>
              <AreaChart
                width={500}
                height={300}
                data={data}
                margin={{
                  top: 5,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                <XAxis dataKey="hour" />
                <YAxis />
                <Tooltip />
                <Legend />
                {messageTypes.map((type) => {
                  return (
                    <Area
                      key={type}
                      type="monotone"
                      dataKey={type}
                      stackId="1"
                      stroke={messageTypeColors[type]}
                      fillOpacity={0.3}
                      fill={messageTypeColors[type]}
                    />
                  );
                })}
              </AreaChart>
            </ResponsiveContainer>
          )}
        </Card.Body>
      </Card>
    </Col>
  );
};

export default MessagesOverTimeChart;
